module.exports = __webpack_public_path__ + "img/sticky_note_2_outlined.0a43f5ff.svg";